import PropTypes from "prop-types";
import styleSchema from "./NavBar.styles";

const NavBar = ({ children, className }) => (
  <div className={`${styleSchema.regular} ${className}`}>{children}</div>
);

NavBar.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

NavBar.defaultProps = {
  className: "",
};

export default NavBar;
